/** Get severity string based on CVSS score.
 * @param scoreRaw CVSS score
 * @returns CVSS score severity
 */
export function getCvssSeverity(scoreRaw) {
    const score = Math.round(scoreRaw * 10) / 10;
    if (score >= 9.0)
        return "critical";
    else if (score >= 7.0 && score <= 8.9)
        return "high";
    else if (score >= 4.0 && score <= 6.9)
        return "medium";
    else
        return "low";
}
//# sourceMappingURL=vulnerabilities.js.map